import { axiosInstance } from 'services/anonApi';
import { IRegion } from './SEOLinking.interfaces';

export default {
  async getSEOLinks() {
    return axiosInstance.get<IRegion[]>('event/footer_elements/');
  },
};
